import ahoy from "ahoy.js";

ahoy.configure({
  urlPrefix: "",
  visitsUrl: "/ahoy/visits",
  eventsUrl: "/ahoy/events",
  visitDuration: 4 * 60,
  withCredentials: true,
});

export default ahoy;

export function trackBoardEvent(name, properties = {}) {
  ahoy.track(name, { source: "board_editor", ...properties });
}
